import { Input as AntInput } from 'antd';
import { SearchProps as AntSearchProps } from 'antd/lib/input';

export type SearchProps = {
  id?: string;
};

const Search = (props: SearchProps & AntSearchProps) => {
  const { className } = props;
  const classNames = [className, 'input', 'search'];
  return <AntInput.Search {...props} className={classNames.join(' ')} />;
};

Search.defaultProps = {
  disabled: false,
  size: 'middle',
  allowClear: true,
};

export default Search;
